module.exports = __webpack_public_path__ + "img/Pattern04.75289666.png";